import { STRINGS } from '../constants';
import type { xplatData } from '../types';

export function formatError(error: unknown): string {
  if (typeof error === 'string') return error;
  if (error && typeof error === 'object' && 'message' in error) return String((error as any).message);
  return STRINGS.errors.unexpected;
}

// Process image URLs to ensure they're properly formatted
const formatImageUrl = (url: string): string => {
	if (!url) return "";
	// If already absolute, return as is
	if (url.startsWith("http://") || url.startsWith("https://")) {
		return url;
	}
	const baseUrl = "https://ule360-media-obj.nyc3.cdn.digitaloceanspaces.com/";
	return `${baseUrl}${url}`;
};


export function mapXplatData(apiData: any): xplatData {
  return {
    id: apiData.id,
    builder_id: apiData.builder_id,
    title: apiData.title,
    slug: apiData.slug,
    communityImage: apiData.community_image ? formatImageUrl(apiData.community_image) : "",
    svgImage: apiData.svg_image ? formatImageUrl(apiData.svg_image) : "",
    svgBackgroundImage: apiData.svg_background_image ? formatImageUrl(apiData.svg_background_image) : "",
    description: apiData.description,
    address: apiData.address,
    contact_person: apiData.contact_person,
    contact_number: apiData.contact_number,
    contact_email: apiData.contact_email,
    lots: apiData.lots.map((lot: any) => ({
      id: lot.id,
      plot_id: lot.plot_id,
      alias: lot.alias,
      groupID: lot.groupID,
      price: lot.price,
      phase: lot.phase,
      image: lot.image ? formatImageUrl(lot.image) : "",
      legend_id: lot.legend_id,
      exterior_link: lot.exterior_link,
      colorcode: lot.colorcode,
      name: lot.name
    })),
    amenities: apiData.amenities.map((amenity: any) => ({
      id: amenity.id,
      plot_id: amenity.plot_id,
      name: amenity.name,
      groupID: amenity.groupID,
      address: amenity.address,
      type: amenity.type,
      image: amenity.image ? formatImageUrl(amenity.image) : "",
      location: amenity.location 
    })),
    gallery: apiData.community_gallery?.map((img: string) =>
      formatImageUrl(img)
    ) || [],
    legends: apiData.legends
  };
}

// get current subdomain 
export function getSubdomain(){
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  if (parts.length > 2) {
    return parts[0]; 
  } else if (hostname.includes('localhost')) {
    return parts[0]; 
  }
  return null;
};

// save to localStorage with expiry
export function setLocalStoreage(key: string, value: any, ttlHours = 24) {
  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + ttlHours * 60 * 60 * 1000,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

// get and validate expiry
export function getLocalStoreage(key: string) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  try {
    const item = JSON.parse(itemStr);
    if (!item?.expiry || new Date().getTime() > item.expiry) {
      // expired or malformed
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch {
    return null;
  }
}